import React, { useEffect } from 'react';
import Lenis from 'lenis';
import './landing.css';
import { LandingI18nProvider, langByCode } from './i18n';
import LandingNav from './LandingNav';
import LandingHero from './LandingHero';
import LandingMarquee from './LandingMarquee';
import LandingEmployer from './LandingEmployer';
import LandingHowItWorks from './LandingHowItWorks';
import LandingEmployeeApp from './LandingEmployeeApp';
import LandingUseCases from './LandingUseCases';
import LandingPricing from './LandingPricing';
import LandingFaq from './LandingFaq';
import LandingCTA from './LandingCTA';
import LandingFooter from './LandingFooter';

const LandingPage = ({ lang = 'SK' }) => {
  useEffect(() => {
    document.documentElement.lang = langByCode(lang).htmlLang;
  }, [lang]);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Lenis smooth scroll — "maslový" pocit celej stránky; vypnutý pri reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const lenis = new Lenis({ lerp: 0.1, wheelMultiplier: 1 });
    window.__lenis = lenis; // pre scrollUtils (kotvy v nav)
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <LandingI18nProvider lang={lang}>
      <div className="landing-page">
        <LandingNav />
        <main>
          <LandingHero />
          <LandingMarquee />
          <LandingEmployer />
          <LandingHowItWorks />
          <LandingEmployeeApp />
          <LandingUseCases />
          <LandingPricing />
          <LandingFaq />
          <LandingCTA />
        </main>
        <LandingFooter />
      </div>
    </LandingI18nProvider>
  );
};

export default LandingPage;
